import React from "react";
import { SFUseStyled, SFAvatar, SFMoreMenu } from "@sf-core";

import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

const { styled } = SFUseStyled();

const CardStyled = styled(
  "div",
  {}
)(({ theme }) => ({
  background: "linear-gradient(180deg, #2E2E38 0%, #23232F 100%)",
  color: theme.palette.white.main,
  boxShadow: "0px 10px 40px 0px #00000026",
  position: "relative",
  borderRadius: 6,
  //height: 95,
  display: "flex",
  alignItems: "center",
  ".card-container": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  ".MuiIconButton-root.more-button": {
    color: theme.palette.white.main,
    position: "absolute",
    top: 0,
    right: 0,
  },
  ".content-container": {
    display: "flex",
    justifyContent: "flex-start",
    flex: 1,
  },
  ".content-container-left, .content-container-right": {
    padding: theme.spacing(2),
    minHeight: 95,
  },
  ".content-container-left": {
    background: "#7474800D",
    width: "95px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    ".title": {
      color: theme.palette.blue200.main,
      fontSize: 22,
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: 1,
      display: "flex",
      alignItems: "center",
      ".MuiSvgIcon-root": {
        fontSize: 10,
      },
      "&.positive": {
        color: theme.palette.green300.main,
      },
      "&.negative": {
        color: theme.palette.red300.main,
      },
    },
    ".subTitle": {
      color: theme.palette.grey225.main,
      fontSize: 12,
      fontWeight: 300,
      lineHeight: "14px",
    },
  },
  ".content-container-right": {
    padding: "0 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
}));

const ProfileTileStyled = styled(
  "div",
  {}
)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  ".profile-avatar": {
    marginRight: theme.spacing(1),
  },
  ".profile-details": {
    ".profile-title": {
      color: theme.palette.grey225.main,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "18px",
      cursor: "pointer",
      "&:hover": {
        color: theme.palette.blue200.main,
      },
    },
    ".profile-subTitle": {
      color: theme.palette.grey225.main,
      fontSize: 12,
      fontWeight: 300,
      lineHeight: "18px",
    },
    ".progress-bar": {
      marginTop: "5px",
    },
  },
}));

const SFAvatarStyled = styled(SFAvatar)(() => ({
  width: 35,
  height: 35,
  fontSize: 20,
}));

const getStateIcon = (state) => {
  if (state == "positive") {
    return <ArrowUpward />;
  }
  if (state == "negative") {
    return <ArrowDownward />;
  }
};

export const SFHeroTile = ({ title, subTitle, state = null }) => (
  <>
    <div className={`title ${state}`}>
      {getStateIcon(state)} {title}
    </div>
    <div className="subTitle">{subTitle}</div>
  </>
);

const ProgressBarStyled = styled("div")(({ value, theme }) => ({
  width: "100%",
  height: "3px",
  backgroundColor: "#747480",
  borderRadius: 4,
  "& .complete": {
    width: `${value}%`,
    height: "3px",
    backgroundColor: "#4EBEEB",
    borderRadius: 4,
  },
}));

export const SFProfileTile = ({
  avatar,
  title,
  subTitle,
  progress = null,
  onClick = () => {},
}) => (
  <ProfileTileStyled>
    <div className="profile-avatar">
      <SFAvatarStyled src={avatar} />
    </div>
    <div className="profile-details">
      <div className="profile-subTitle">{subTitle}</div>
      <div onClick={onClick} className="profile-title">
        {title}
      </div>
      {progress !== null && (
        <ProgressBarStyled value={progress} className="progress-bar">
          <div className="complete"></div>
        </ProgressBarStyled>
      )}
    </div>
  </ProfileTileStyled>
);

export const SFDetailTile = ({ avatar, title, subTitle }) => (
  <ProfileTileStyled>
    <div className="profile-details">
      <div className="profile-title">{title}</div>
      <div className="profile-subTitle">{subTitle}</div>
    </div>
  </ProfileTileStyled>
);

const SFHeroCard = ({ title, actions, leftContent, children }) => {
  return (
    <CardStyled>
      <div className="card-container">
        <SFMoreMenu items={actions} />
        <div className="content-container">
          {leftContent && (
            <div className="content-container-left">{leftContent}</div>
          )}
          <div className="content-container-right">{children}</div>
        </div>
      </div>
    </CardStyled>
  );
};

export default SFHeroCard;
